import script from "./ChShapes.vue?vue&type=script&setup=true&lang=js"
export * from "./ChShapes.vue?vue&type=script&setup=true&lang=js"

import "./ChShapes.vue?vue&type=style&index=0&id=6a3ac31d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a3ac31d"]])

export default __exports__